import {defineStore} from 'pinia'
import {useTheme, useLocale} from "vuetify";

export const useInterfaceStore = defineStore('interface', () => {
    const theme = useTheme()
    const {locale} = useI18n()
    const {user} = useAuth()
    const {current: vuetifyLocale} = useLocale()

    const openedDrawer: Ref<boolean|null> = ref(null)
    const showPreferredChannelsOnly = ref<boolean>(false)

    const darkTheme = computed({
        get() {
            return theme.global.name.value === 'dark'
        },
        set(newValue: boolean) {
            // Змінюємо тему
            theme.global.name.value = newValue ? 'dark' : 'light'

            // Оновлюємо на рівні сесії
            localStorage.setItem('blackTheme', newValue ? '1' : '0')

            // Оновлюємо в профілі без очікування результату,
            // щоб не блокувати перемикач, для збереження між пристроями
            if (!user.value?.impersonatedBy) {
                useApi().updateUserProfile({request: {darkTheme: newValue}}).finally()
            }
        }
    })

    const curLocale = computed({
        get() {
            return locale.value
        },
        set(newValue: string) {
            locale.value = newValue
            vuetifyLocale.value = newValue

            if (!user.value?.impersonatedBy) {
                useApi().updateUserProfile({request: {locale: newValue}}).finally()
            }
        }
    })

    // Для початку намагаємось підвантажити з localStorage
    if (localStorage.getItem('openedDrawer') !== null) {
        openedDrawer.value = Boolean(parseInt(localStorage.getItem('openedDrawer') || '0'))
    }

    // Для початку намагаємось підвантажити з localStorage
    if (localStorage.getItem('showPreferredChannelsOnly') !== null) {
        showPreferredChannelsOnly.value = Boolean(parseInt(localStorage.getItem('showPreferredChannelsOnly') || '0'))
    } else if (!user.value?.impersonatedBy) {
        useApi().getUserProfile().then(profile => {
            showPreferredChannelsOnly.value = profile.showPreferredChannelsOnly
        })
    }

    if (!user.value?.impersonatedBy) {
        useApi().getUserProfile().then(profile => {
            // darkTheme.value = profile.darkTheme
            theme.global.name.value = profile.darkTheme ? 'dark' : 'light'
            locale.value = profile.locale
            vuetifyLocale.value = profile.locale
        })
    }

    // По виходу з системи скидається стан сховища
    const $reset = () => {
        // darkTheme.value = null
        openedDrawer.value = null
        showPreferredChannelsOnly.value = false
    }

    watch(openedDrawer, (newValue) => {
        // Оновлюємо на рівні сесії (для того щоб значення по замовчуванню збереглось
        localStorage.setItem('openedDrawer', newValue ? '1' : '0')
    })

    watch(showPreferredChannelsOnly, (newValue: boolean) => {
        // Оновлюємо на рівні сесії (для того щоб значення по замовчуванню збереглось
        localStorage.setItem('showPreferredChannelsOnly', newValue ? '1' : '0')

        // Оновлюємо в профілі без очікування результату,
        // щоб не блокувати перемикач, для збереження між пристроями
        if (!user.value?.impersonatedBy) {
            useApi().updateUserProfile({request: {showPreferredChannelsOnly: newValue}}).finally()
        }
    })

    return {
        darkTheme,
        curLocale,
        openedDrawer,
        showPreferredChannelsOnly,
        $reset,
    }
})